import React, { useRef, useState, useEffect } from "react";
import _ from "lodash";
import XLSX from "xlsx";
import ReviewSubmissionModal from "./ReviewSubmissionModal";
import Notice from "../Notice";
import MixpanelService from "../utils/MixpanelService";
import { Schema } from "./shared/Fields";
import SubmissionCard from "./SubmissionCard";

const PARAMS_PREFIXES = {
  pharmacy: "submission",
  medical: "medical_submission",
  pharmacy_encounter: "pharmacy_encounter_submission",
  medical_encounter: "medical_encounter_submission",
};

const Post = (props) => {
  const paramsPrefix = PARAMS_PREFIXES[props.submissionType] || "submission";
  const [displayConfirmation, setDisplayConfirmation] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submittingRef = useRef(false);
  const [notice, setNotice] = React.useState({
    kind: "error",
    open: false,
    message: "",
  });

  const submissionStats = {
    numFiles: props.data.length,
    total: props.data.reduce((acc, attachment) => acc + attachment.totalRows, 0),
    selected: props.data.reduce((acc, attachment) => acc + attachment.selectedRows, 0),
    submittable: props.data.reduce((acc, attachment) => acc + attachment.submittableRows.length, 0),
    failedToDeIdentify: props.data.some((a) => a.failedToDeIdentify),
  };

  const buildWorkbook = () => {
    const workbook = XLSX.utils.book_new();
    const headers = _.keys(Schema[props.submissionType]);
    const sheet = XLSX.utils.aoa_to_sheet([headers]);

    _.forEach(props.data, (file, index) => {
      XLSX.utils.sheet_add_json(sheet, file.submittableRows, {
        skipHeader: true,
        blankrows: false,
        origin: index === 0 ? "A2" : -1,
      });
    });

    XLSX.utils.book_append_sheet(workbook, sheet, "340B ESP™");
    return workbook;
  };

  const writeWorkbook = (_callback) => {
    const workbook = buildWorkbook();
    _callback(XLSX.write(workbook, { bookType: "csv", type: "array" }));
  };

  const handleSubmission = () => {
    if (props.data.length < 1 || submittingRef.current) return;
    submittingRef.current = true;
    setSubmitting(true);

    writeWorkbook(postSubmission);
  };

  const postSubmission = (csv) => {
    // TODO
    // ensure data submitting is validated before post
    var formData = new FormData();

    formData.append(`${paramsPrefix}[uploads]`, new File([csv], `${props.submissionName}.csv`));
    formData.append(`${paramsPrefix}[name]`, props.submissionName);

    fetch(props.submissionPath, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      },
      body: formData,
    })
      .then((res) => {
        return res.json().then((data) => {
          if (!res.ok) {
            throw new Error(data.error);
          }

          location.href = data.path;
        });
      })
      .catch((error) => {
        props.clearAttachments();
        setNotice({
          kind: "error",
          open: true,
          message: error.message,
        });
      })
      .finally(() => {
        submittingRef.current = false;
        setSubmitting(false);
      });
  };

  return (
    <>
      <Notice details={notice} />
      <SubmissionCard
        submissionName={props.submissionName}
        setSubmissionName={props.setSubmissionName}
        submissionPath={props.submissionPath}
        submitting={submitting}
        onSubmit={() => setDisplayConfirmation(true)}
        setLeavePageLink={props.setLeavePageLink}
        submissionStats={submissionStats}
      />
      {displayConfirmation && (
        <ReviewSubmissionModal
          displayModal={displayConfirmation}
          setModalState={setDisplayConfirmation}
          action={handleSubmission}
          data={props.data}
          submissionType={props.submissionType}
          submissionName={props.submissionName}
        />
      )}
    </>
  );
};

export default Post;
